import { render, staticRenderFns } from "./PurchaseGift.vue?vue&type=template&id=575d12d4&scoped=true&"
import script from "./PurchaseGift.vue?vue&type=script&lang=js&"
export * from "./PurchaseGift.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseGift.vue?vue&type=style&index=0&id=575d12d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575d12d4",
  null
  
)

export default component.exports